const debug = true
const allList = ["af","sq","am","ar","hy","az","bn","bs","bg","ca","zh","zh-Hant","hr","cs","da","nl","et","en","fa","fil","fi","fr","ka","de","el","gu","ht","ha","he","hi","hu","is","id","ga","it","ja","kn","kk","ko","lv","lt","mk","ms","ml","mt","mr","mn","no","ps","pl","pt","pa","ro","ru","sr","si","sk","sl","so","es","sw","sv","ta","te","th","tr","uk","ur","uz","vi","cy", "sq"]

export default {
	debug: debug,
	home: debug ? "https://dev-www.portuguesepal.com" : "https://www.portuguesepal.com",
	domain: debug ? "https://dev-talk.portuguesepal.com" : "https://talk.portuguesepal.com",
	host: debug ? "https://dev-api.portuguesepal.com/" : 'https://api.portuguesepal.com/',
	package: 'calteacher',
	requestVersion: "2.2.0",
	platform: "web",
	version: '2.2.0',
	base: debug ? "https://d39pqoqy26oopx.cloudfront.net/" : "https://d2t67mnqzbky1s.cloudfront.net/",
	allList: allList,
	googleClientID: "731984415304-jau2tj1dlf5o0derpruq6c4p6e8bft03.apps.googleusercontent.com",
	appleClientID: "com.portuguesepal.web"
}
